import {
    BRANDSETTINGS,
    BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS,
    BRAND_ADMIN_UPDATE_EMAIL_IMAGE_START,
    BRAND_ADMIN_UPDATE_PERMISSIONS,
    PAYMENT_CONFIGURATIONS_SAVE,
} from "constants/action-types";

export const updatePreferredRetailers = (retailersLinks) => ({
    payload: retailersLinks,
    type: BRANDSETTINGS.PREFERREDRETAILERS.UPDATE.START,
});

export const fetchPreferredRetailers = (ruleId) => ({
    payload: ruleId,
    type: BRANDSETTINGS.PREFERREDRETAILERS.FETCH.START,
});

export const clearEmailHeaderImage = (payload) => ({
    payload,
    type: BRAND_ADMIN_UPDATE_EMAIL_IMAGE_START,
});

export const updatePermissions = (payload) => ({
    payload,
    type: BRAND_ADMIN_UPDATE_PERMISSIONS,
});

export const updateCustomRolesPermissions = (payload) => ({
    payload,
    type: BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS,
});

export const savePaymentConfigurations = (payload) => ({
    payload,
    type: PAYMENT_CONFIGURATIONS_SAVE,
});
